<template>
  <div>
    <card v-if="!isLogin && !loginError" type="secondary" shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-5 py-lg-5"
            class="border-0">
          <template>
              <div class="text-center text-muted mb-4">
                  <small>Sign in with credentials</small>
              </div>
              <form id="form" role="form" @submit.prevent ref="form">
                  <base-input alternative
                              class="mb-3"
                              autocomplete="on"
                              required='required'
                              placeholder="Email"
                              addon-left-icon="ni ni-email-83"
                              name='email'
                              v-model="email"
                              type="text"
                              addonRightIcon=''
                              v-validate="'required|email'"
                              data-vv-validate-on="blur"
                              :error="vErrors.first('email')">
                  </base-input>
                  <base-input alternative
                              type="password"
                              autocomplete="on"
                              required='required'
                              placeholder="Password"
                              addon-left-icon="ni ni-lock-circle-open"
                              v-validate="'required'"
                              data-vv-validate-on="blur"
                              :error="vErrors.first('password')"
                              name='password'
                              v-model="password">
                  </base-input>
                  <base-checkbox v-model="rememberMe">
                      Remember me
                  </base-checkbox>
                  <div class="text-center">
                      <base-button type="primary" @click="login" :disabled="disabledSignButton" nativeType='submit' class="my-4">Sign In</base-button>
                  </div>
              </form>
          </template>
      </card>
      <div v-if="isLogin && !loginError" gradient="danger" class="my-3 text-center">
          <i class="ni ni-check-bold ni-3x"></i>
          <h4 v-if="loginResponse.result" class="heading mt-4">{{ loginResponse.result.message }}</h4>
      </div>
      <div v-if="loginError" gradient="danger" class="my-3 text-center">
          <i class="fa fa-exclamation fa-3x warning" aria-hidden="true"></i>
          <h4 class="heading mt-3 warning">{{ loginError }}</h4>
      </div>
    </div>
</template>

<script>
import locationMixin from './../mixins/locationMixin'
import alertMixin from './../mixins/alertMixin'
import jobsMixin from './../mixins/jobsMixin'
import customFormsMixin from './../mixins/customFormsMixin'
import stateUpdateMixin from './../mixins/stateUpdateMixin'
import driverInfoMixin from './../mixins/driverInfoMixin'
export default {
  data () {
    return {
      disabledSignButton: false,
      email: '',
      password: '',
      rememberMe: false,
      loginResponse: '',
      loginError: null
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    },
    token () {
      return this.$store.state.user.token
    }
  },
  methods: {
    login (e) {
      let self = this
      self.disabledSignButton = true
      this.$validator.validateAll({
        email: self.email,
        password: self.password,
        rememberMe: self.rememberMe
      }).then(function (result) {
        if (result) {
          let loginData = {
            email: self.email,
            password: self.password,
            rememberMe: self.rememberMe
          }
          self.$store.dispatch('login', loginData)
            .then(response => {
              let token = response.data.result.token
              if (token) {
                self.prepareToWork(response.data, e)
              }
            })
            .catch(err => {
              self.disabledSignButton = false
              self.loginError = err.response.data.result.message || 'Email or password is wrong'
              setTimeout(function () {
                self.formReset(null)
                self.loginError = null
              }, 2000)
            })
        } else {
          self.disabledSignButton = false
        }
      })
    },
    async prepareToWork (responseData, e) {
      let token = responseData.result.token
      try {
        let response = await this.getState(token)
        try {
          let state = JSON.parse(response.data.result.state)

          // temp fix to overcome localStorage cache. Can be deleted in a while
          if (state && typeof state.standClass.NRS === 'undefined') {
            state.standClass.NRS = 8
          }

          if (state) {
            // Get state data from server and delete saved jobs to get the newest jobs version data
            this.updateState(state)
            this.deleteJobs()
          }
        } catch (error) {
          console.log(error)
        }

        this.$store.commit('changeLoginStatus', true)
        this.$store.commit('tokenChange', token)
        this.$store.commit('tokenRefreshTime', Date.now())
        this.loginResponse = responseData
        // Get location info save to localStorage and send it to server
        this.getLocation()
        this.formReset(null)
        this.getJobs()
        this.getCustomForms()
        this.getDriverInfo()
        this.closeModalresetForm()
      } catch (error) {
        console.log(error)
      }
    },
    async getCustomForms () {
      await this.uploadSaveCustomForms()
    },
    formReset (e) {
      this.email = this.password = this.rememberMe = null
      if (e) {
        e.target.reset()
      }
    },
    closeModalresetForm () {
      let self = this
      setTimeout(function () {
        self.loginError = null
        self.$emit('closeModal')
        self.formReset(null)
      }, 2000)
    }
  },
  mixins: [alertMixin, jobsMixin, locationMixin, stateUpdateMixin, customFormsMixin, driverInfoMixin]
}
</script>
